import { render, staticRenderFns } from "./access-control.vue?vue&type=template&id=095ba5fc&"
import script from "./access-control.vue?vue&type=script&lang=js&"
export * from "./access-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports